import React from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import { NodePill } from "src/base-components/NodePill";
import { BeMappedNode } from "src/constants/NodeDataTypes";
import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  node?: BeMappedNode | null;
  onReset: VoidFunction;
};

export const TitleRightContent: React.FC<Props> = ({ node, onReset }) => {
  return (
    <>
      <div className="mr-1 ml-auto flex max-w-56 items-center">
        {node && <NodePill node={node} />}
      </div>
      <span className="ml-2 text-gray-200">|</span>
      <Tooltip placement="bottom" title="Start a new chat" asChild>
        <IconButton icon={faPlus} size="xs" onClick={onReset} />
      </Tooltip>
    </>
  );
};
